import { request } from "services/api/util";

class ProductTypeService {
  async getListProductType(param) {
    const config = {
      method: "get",
      url: `admin/productTypes`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ProductTypeService();
